import React from 'react';
import css from './OpenRolesArabibi.module.css';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
import { useIntl } from 'react-intl';

function OpenRolesArabibi() {
  const intl = useIntl();
  const t = (id, def) => intl.formatMessage({ id, defaultMessage: def });

  const rolesList = [
    {
      title: t('OpenRoles.role1.title', 'Arabic Tutors'),
      description: t('OpenRoles.role1.desc', 'Inspire learners through live online lessons.'),
      location: t('OpenRoles.role.location', '100% Remote'),
      time: t('OpenRoles.role.time', 'Full-time'),
    },
    {
      title: t('OpenRoles.role2.title', 'UX/UI Designers'),
      description: t('OpenRoles.role2.desc', 'Shape how the world experiences Arabibi.'),
      location: t('OpenRoles.role.location', '100% Remote'),
      time: t('OpenRoles.role.time', 'Full-time'),
    },
    {
      title: t('OpenRoles.role3.title', 'Content Writers'),
      description: t('OpenRoles.role3.desc', 'Share stories that connect language and culture.'),
      location: t('OpenRoles.role.location', '100% Remote'),
      time: t('OpenRoles.role.time', 'Full-time'),
    },
    {
      title: t('OpenRoles.role4.title', 'Developers'),
      description: t('OpenRoles.role4.desc', 'Build seamless, scalable classroom features.'),
      location: t('OpenRoles.role.location', '100% Remote'),
      time: t('OpenRoles.role.time', 'Full-time'),
    },
  ];

  return (
    <div className={css.openRolesArabibi}>
        <div className={css.openRolesArabibiContent}>
            <div className={css.openRolesArabibiTitle}>
              {t('OpenRoles.title', 'We’re hiring!')}
            </div>
            <div className={css.openRolesArabibiHeading}>
              {t('OpenRoles.heading', 'Open Roles at Arabibi')}
            </div>
            <div className={css.openRolesArabibiDescription}>
              {t(
                'OpenRoles.description',
                'Explore opportunities to join a mission-driven team shaping the future of Arabic learning.'
              )}
            </div>
            <div className={css.roleWrapper}>
                {rolesList.map((item , i)=>{
                    return(
                    <div key={`role-${i}`} className={css.roleItem}>
                        <div className={css.roleLeftSide}>
                            <div className={css.roleItemTitle}>{item.title}</div>
                            <div className={css.roleItemDescription}>{item.description}</div>
                        </div>
                        <div className={css.roleRightSide}>
                            <div className={css.roleItemBadge}>
                                <IconCard type="location" />
                                {item.location}
                            </div>
                            <div className={css.roleItemBadge}>
                                <IconCard type="time" />
                                {item.time}
                            </div>
                        </div>
                    </div>
                    )
                })}
            </div>
            <div className={css.roleMessagesWrapper}>
                <div className={css.messageIcon}>
                    <IconCard type="lovemessage" />
                </div>
                <div className={css.messageDescription}>
                    {t(
                      'OpenRoles.footer.note',
                      'Don’t see a role that fits? Send us your profile anyway — we love hearing from passionate people.'
                    )}
                </div>
                <div className={css.messageEmail}>
                    <IconCard type="email" />
                   {t('OpenRoles.footer.email', 'careers@arabibi.com')}
                </div>
            </div>
        </div>
    </div>
  )
}

export default OpenRolesArabibi